import React from 'react'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'

/** Blue "Coming soon" chip shown beside a feature that has not shipped yet. */
function ComingSoonChip() {
  return (
    <span className='inline-flex items-center gap-1 whitespace-nowrap rounded-pill bg-chalk-50 px-2 py-0.5 text-10 font-bold text-chalk'>
      <AutoAwesomeIcon sx={{ fontSize: 13 }} />
      Coming soon
    </span>
  )
}

export default ComingSoonChip
